export default {
  'bank-account': '계좌',
  'confirm-password': '@:pages.password.bank-account @:terms.password @:terms.confirm',
  // eslint-disable-next-line max-len
  'bank-account-password': '@:pages.password.bank-account @:terms.password (숫자 @:pages.password.four-words)',
  'password': '@:pages.password.bank-account @:terms.password',
  'otp': 'OTP @:terms.password',
  'error': {
    'payment': '@:terms.payment @:terms.register에 실패하였습니다.',
  },
  'message': {
    'complete': {
      'title': '@:terms.payment하고 있습니다.',
      'description': '5분내에 완료되며, 카카오톡으로 알려드리겠습니다.',
    },
    'plz-password': '@:terms.password를 입력해주세요.',
  },
  'payment-register': '@:terms.payment하기',
  'four-words': '4자리',
  'password-four': '@:terms.password @:pages.password.four-words',
  'confirm': '@:terms.confirm',
  'cancel': '@:terms.cancel',
  'verification': {
    'max-length': '@:terms.password를 확인해주세요. (영문 숫자 8자리)'
  },
  'otp-notice':{
    'first': '최대 1분이 소요될 수 있습니다.',
    'second': ['OTP @:terms.password 확인이 늦어지고 있습니다.', '완료시 카톡으로 알려드리겠습니다.']
  }
}
